import { Categories, DeviceTypes, PageType } from '@gumtree/shared/src/types/client-data';
import { AD } from '@gumtree/shared/src/model/generic.model';

export interface DeviceMeta {
    type?: DeviceTypes;
    os?: string;
    mobile?: boolean;
    tablet?: boolean;
}

export interface ThreatMetrix {
    orgId: string;
    sessionId: string;
    pageType: string;
    webBaseUrl: string;
}

export interface BaseConfigState {
    device: DeviceMeta;
    cookiePolicySeen: boolean;
    domain: string;
    environment: string;
    isQA: boolean;
    isDev: boolean;
    location: string;
    loginUrl: string;
    /** Same as `buyerUrl` on QA/prod, but not in dev */
    bffUrl: string;
    buyerUrl: string;
    sellerBaseUrl: string;
    sellerUrl: string;
    canonicalUrl: string;
    robots: 'noindex,nofollow' | null | undefined;
    urlQueryParams: Record<string, string>;
    facebook_app_id: string;
    google_app_id: string;
    pageType: PageType;
    showReduxDevTools: boolean;
    currentPageUrl: string;
    category: Categories;
    threatMetrixTracking: ThreatMetrix;
    sentryDSN: string;
    requestId: string;
    brazeApiKey: string;
    brazeBaseUrl: string;
    gtGetModel: string;
    /** User type from Set-Cookie header (gt_userType), used when model.userType is not available */
    userType?: string;
    /** Whether the browser is Safari (detected on server side) */
    isSafari?: boolean;
    /** Device ID from Set-Cookie header (gt_p) */
    deviceId?: string;
    /** Session ID from Set-Cookie header (gt_s) */
    sessionId?: string;
}

const initialState = {
    device: {},
} as BaseConfigState;

export const UPDATE_BASE_CONFIG = 'UPDATE_BASE_CONFIG';

export const updateBaseConfig: AD<typeof UPDATE_BASE_CONFIG, Partial<BaseConfigState>> = (
    payload
) => {
    return {
        type: UPDATE_BASE_CONFIG,
        payload,
    };
};

export default (state = initialState, action): BaseConfigState =>
    action.type === UPDATE_BASE_CONFIG ? { ...state, ...action.payload } : state;
